"use strict";
// Source: https://docs.google.com/spreadsheets/d/10zKgiZqadfsZC0Kuv7dq2l7Zoq4FML4_nMVdHAqbJow
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRevenueCatPublicApiKeyByAppTypeAndPlatform = exports.getAppTypeByProductId = exports.AppleBundleIdToRevenueCatAppleServerNotificationsUrlMap = exports.AndroidAppTypeRevenueCatApiKeyMap = exports.iOSAppTypeRevenueCatApiKeyMap = exports.REVENUE_CAT_NOT_IMPLEMENTED = void 0;
const appPlatform_1 = require("./appPlatform");
const productIdAppTypeMap_1 = require("./productIdAppTypeMap");
exports.REVENUE_CAT_NOT_IMPLEMENTED = 'revenue_cat_not_implemented';
exports.iOSAppTypeRevenueCatApiKeyMap = {
    int: 'appl_VqsLewLtvpAehRkwcGAGihGpdKq',
    droplets: 'appl_jrQCVANpeIEuBNJbPlTVXKOrAUl',
    lang_ru: 'appl_aojQNdUkvneNKJowQUOpJzzaBDz',
    lang_ar: 'appl_wnUqHVEigveZYfmVuqIqcoYyEyv',
    lang_zh: 'appl_lWLTvFpjrhANMksUQqGGCbJuUHe',
    lang_da: 'appl_ZadMVLiVHkvAQmWZhiowTRARbqG',
    lang_he: 'appl_VTwphvkTLSotxqMopeVZKTFpIGR',
    lang_hu: 'appl_KdTHESCkNCeRDhFqpoWuVnsCxMu',
    lang_ja: 'appl_GFPCfBCcesEDTzEMTVEehsttwqz',
    lang_ko: 'appl_uoeYHmvttKeLYhORTnDzJTwJSIq',
    lang_it: 'appl_UvHCIMwmBuEBHLzXizjaGIHLaWZ',
    lang_ptbr: 'appl_RYJLGYvYlqXnXxiqTjuPwibQewA',
    lang_no: 'appl_svJHMhCPeRjUsrCqNHYgMqJZITq',
    lang_sv: 'appl_wNTbZVfwieHfNvSvyAZsxxCzIcB',
    lang_eo: 'appl_jhYhwZkDczwDLXpesMaYvtdzQam',
    lang_tl: 'appl_AeVTFRYCRtMScZrZmDAoVKoaeFt',
    lang_tr: 'appl_BIWirIPMiedCTEpIzMURKYpxwJT',
    lang_vi: 'appl_cutLFeJCTOnohRREHImqFmZmXKv',
    lang_hi: 'appl_QHNMSgNsNshDqOzWJoXhilgRQgK',
    lang_ic: 'appl_PowiwMfaDCqpljCGddwCMewEnMM',
    lang_nl: 'appl_bnKhUXLwbuOpNBRmKJrsrhMMzxV',
    lang_id: 'appl_OyQNUkwEuLLbMzudiTXuViCcUrZ',
    lang_enus: 'appl_gsFtijXvPPiOjHqjjJeMqZdOnCe',
    lang_pt: 'appl_wLvxRropxxaEgkpZppwpfgxJKie',
    lang_esmx: 'appl_NDkQAtZSUludKeXkxqAwIkxBEmf',
    lang_zhyue: 'appl_fnONjNMZezVMhEuCFJaEZZXfByE',
    scripts: 'appl_mdEJovNgDhoydKHKzTOrBkELRfU',
    lang_es: 'appl_hAKoSUrUhaLzkddbXBrFpNbicTE',
    lang_fr: 'appl_wHCVvZSzEAUvmxoglhXnYptPFfE',
    lang_de: 'appl_NlZSRqmooAbPwVaYRWgPBIKweXr',
    lang_en: 'appl_cqYlnpquJqEsTMuFzlJmjfSMfbo',
    local_hu: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    local_ar: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_pl: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_th: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    local_zh: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    global_eagle: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_haw: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_mi: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_sm: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_el: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_fi: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_fa: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_hr: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_et: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_sr: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_bs: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    lang_ain: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    droplets_demo_apple_store: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    upopoy: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    bite: exports.REVENUE_CAT_NOT_IMPLEMENTED,
};
exports.AndroidAppTypeRevenueCatApiKeyMap = {
    int: 'goog_NRNYvUaFizICqmblGstoAtgXHkm',
    droplets: 'goog_cRxgHSSBLZtnkORJFIybhfsusBB',
    lang_da: 'goog_bwfwGSZIAPjxigOtVPGZwCpKbNz',
    lang_eo: 'goog_mZmhctVfTZDdtINTXhTvxnqhPOR',
    lang_hu: 'goog_FOaUttODiPRQWVdimAuWwwgAsGR',
    lang_no: 'goog_IyTKJdNCiPFCIZgLkenIxlBIWdI',
    local_hu: 'goog_NHSlBGIQtHsxyhXKaRIvWgrYUEL',
    lang_ain: 'goog_HplVmBpgGjesnoVBQhmWkjkXkse',
    lang_bs: 'goog_kfViXvroYEqJrrKodEKEDhxRZIK',
    lang_hr: 'goog_kabNYqHjIqZWNEKylvEblWAlGhO',
    lang_nl: 'goog_kWMKslkkreFCUbKkkhDPccfpxWh',
    lang_enus: 'goog_qFLEtSbrDyAxErhCpbXpAfndiBo',
    lang_en: 'goog_IzurgRMgjeOpERlKuCSFqAlJtmX',
    lang_fi: 'goog_uragIqqHnVvvUNJnbHivzhXagTN',
    lang_fr: 'goog_CEqlIYAqadWrJBGyMirwlZJKkPK',
    lang_el: 'goog_GeELZosTbkmugTFDDnxnRfWDZcI',
    lang_hi: 'goog_xKNJJheuzgxNiRMsgNAiqamlnjx',
    lang_it: 'goog_yIqeiuaOlKZsRpszDULVOJLuHWU',
    lang_esmx: 'goog_OIDdQOSThJAThIQMbfhMCvZNBBq',
    lang_zh: 'goog_kVuvOFftFHDqhsHstSkNeXMtONy',
    lang_fa: 'goog_QbSnBPyLVqZJZCOPMxMITKGAnDb',
    lang_sr: 'goog_GThsswMSdCKEWAIOuOJIBpahKey',
    lang_es: 'goog_UKyPKZXJaUNBiXTrpAjkdQjAqxF',
    lang_sv: 'goog_oVbimLMfqXxjbKWGGLqyYaMobsR',
    lang_th: 'goog_IDUTZOBVESFEeYJXbmKuBroJbfJ',
    lang_tr: 'goog_fDICVGYNHdYCOYKWcsmRLiibSMc',
    lang_vi: 'goog_vSszSBBxrgNFQZYCXLYmSUmkiES',
    lang_ar: 'goog_AIPCPkfKkmOfYrNOlnHcfQJpYuT',
    lang_ptbr: 'goog_eHGGYgyPHEhCYYnLALMgkJRhQwm',
    lang_zhyue: 'goog_jdgXmZBuqfODwLEEBtJEdjnXtRo',
    scripts: 'goog_dqJgUIzDAYcYtEtKKEwYnIpfCvR',
    lang_et: 'goog_yNpSYvozDJPsUUMFLblwjxxLErQ',
    lang_de: 'goog_GiNlbhPsjgyEIwiHRHtmkGAxHSS',
    lang_haw: 'goog_KiYWzsytssdVBWxDDPNfbbnxMUM',
    lang_he: 'goog_EcNNNRsEkxSvjQVlbqBKuvxvFBX',
    lang_id: 'goog_bXJWCrdJSijIJYiyrfjoXAfCtpJ',
    lang_ic: 'goog_XWqceivhKjBpsqAPhbqLvdeJXzw',
    lang_ja: 'goog_dzQuUnqhDNlmEJLKxbUvjEETWVq',
    lang_ko: 'goog_YBrtEURszPEYYyIulnZEDDKBznB',
    lang_mi: 'goog_aVHVQvkEYGzMhnnhXOPSdJBBvDz',
    lang_pl: 'goog_rioUTkMyCWiHgVhAONpLxaHrnNy',
    lang_pt: 'goog_bIqHkwyWKHUnMrTTKpYYEvsgZkB',
    lang_ru: 'goog_gmNsLXLsynvhTzNYhtodNndxsEG',
    lang_sm: 'goog_tdyXYYakrDdaPOjPcbfWAQzciUf',
    lang_tl: 'goog_IIwZuZwjRSTcUaRnkNIqdrgzYME',
    local_zh: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    local_ar: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    global_eagle: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    droplets_demo_apple_store: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    upopoy: exports.REVENUE_CAT_NOT_IMPLEMENTED,
    bite: exports.REVENUE_CAT_NOT_IMPLEMENTED,
};
exports.AppleBundleIdToRevenueCatAppleServerNotificationsUrlMap = {
    'com.planblabs.drops.italian': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/VkGhEKXlRhWZqbnGfqyqOgvFUmowiiUC',
    'com.planblabs.drops.droplets': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/jyanblgyXgqaKstxNuWUHDkOijCrWLZa',
    'com.planblabs.drops.russian': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/VAXykdgivDAesVYrMvdtDUlHOsdAtXvZ',
    'com.planblabs.drops.arabic': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/YHKOqJpYQVtLLHutEKerzmzCXBcIBsWP',
    'com.planblabs.drops.chinese': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/jLHNnXLZTHnlnpcTRdtdiDhSFFUedCBV',
    'com.planblabs.drops.danish': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/LCKgylxKSjDxvBChiFbEatKFXKSixeLq',
    'com.planblabs.drops.hebrew': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/msUsUnoAupWWhwHEhCnwkqApeMFwHjys',
    'com.planblabs.drops.hungarian': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/RhfTWVOSIHHOIPoFcbHNOhNxViwtzRfH',
    'com.planblabs.drops.japanese': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/iFVgELYfnrqlyTwFsocYGgrsxhoxZRGM',
    'com.planblabs.drops.korean': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/hAoxFJLeDVUwqLtMwHAhPFBEqAIdMNMq',
    'com.planblabs.drops.lang.italian': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/TtkGUOApnqpgLVHdofafMVMCvdONDnMe',
    'com.planblabs.drops.portuguese': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/fkyvfLyabEIenWnebNegvfwwiHJmQJwr',
    'com.planblabs.drops.norwegian': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/OTiVQabtbJbyffaPxhLufpCSMliHkKZv',
    'com.planblabs.drops.swedish': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/GVAuvIbhDJRXWROGqKqEbaTyiiNqSsJb',
    'com.planblabs.drops.esperanto': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/yRishhcamTvPWbTtrlsXRxkelRyoUCbM',
    'com.planblabs.drops.tagalog': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/BpOtmnwkUiLValzoKjVHgvhroIfHrbQE',
    'com.planblabs.drops.turkish': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/eXANaGVHeRucOQcmZPIrjHvCeUyVDWiA',
    'com.planblabs.drops.vietnamese': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/QpjyYNZETpcROwcKQmvUIiRzDqgCqTJC',
    'com.planblabs.drops.hindi': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/QSrDPdknESPNzWrtfkHYUNgbmlZojvUZ',
    'com.planblabs.drops.icelandic': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/LPXfkfNRwFAUcBbBEbxTKlouuoEFWVRa',
    'com.planblabs.drops.dutch': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/PTPLmadJqeqrSdKamVMGkxncDcMeqNug',
    'com.planblabs.drops.indonesian': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/OsLzxFOFWGWmtPObpYckCteTQrMQbxLQ',
    'com.planblabs.drops.english.american': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/UffqgRjJKOJYDFKqWaiezenfLlCYAYJV',
    'com.planblabs.drops.portuguese.europe': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/KDKpSLOQuGufUFIEqGRoSRxSiLLYnpKX',
    'com.planblabs.drops.spanish.latin.american': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/WARwtUBzEYAfwvkaEhZvWNFnvYHVAIbe',
    'com.planblabs.drops.chinese.cantonese': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/aLGcKZDwLWcQAZzRltCrrJsqjNGhpsUhh',
    'com.planblabs.drops.scripts': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/WyimaisNphGIzKyjvzknmgcfsXKrxCXK',
    'com.planblabs.drops.spanish': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/GqKXMnxxlHKmlLmvVFCoGzYMilXmxstl',
    'com.planblabs.drops.french': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/RRnfjXJbxxqrROmwuVPYqTMgPlgsQghF',
    'com.planblabs.drops.german': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/xUZlkMddJSxPhyJSZumszZACXrqziznf',
    'com.planblabs.drops.english': 'https://api.revenuecat.com/v1/incoming-webhooks/apple-server-to-server-notification/YnNNpzAduabnnjTunuREtOqZaTQhCvia',
};
const getAppTypeByProductId = (productId) => {
    return productIdAppTypeMap_1.productIdAppTypeMap[productId];
};
exports.getAppTypeByProductId = getAppTypeByProductId;
const getRevenueCatPublicApiKeyByAppTypeAndPlatform = (appType, appPlatform) => {
    switch (appPlatform) {
        case appPlatform_1.AppPlatform.iOS:
            if (exports.iOSAppTypeRevenueCatApiKeyMap[appType] !== exports.REVENUE_CAT_NOT_IMPLEMENTED) {
                return exports.iOSAppTypeRevenueCatApiKeyMap[appType];
            }
            break;
        case appPlatform_1.AppPlatform.Android:
            if (exports.AndroidAppTypeRevenueCatApiKeyMap[appType] !== exports.REVENUE_CAT_NOT_IMPLEMENTED) {
                return exports.AndroidAppTypeRevenueCatApiKeyMap[appType];
            }
            break;
        default:
            return null;
    }
    return null;
};
exports.getRevenueCatPublicApiKeyByAppTypeAndPlatform = getRevenueCatPublicApiKeyByAppTypeAndPlatform;
